function _(n,s,t){s.exports=n(3)()?Object.assign:n(4)}
//# sourceMappingURL=index.min.js.map